export default __webpack_public_path__ + "static/media/bit5.f6e8118e.svg";